/**
 * Formatage monétaire commun (Intl.NumberFormat, standard du navigateur).
 * SEUL endroit de la console qui formate un montant ou un nombre
 * (ré-audit DU-3, N-12).
 */

const XOF_FORMAT = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'XOF',
  minimumFractionDigits: 0,
});

/** Montant en francs CFA (XOF), sans décimale : « 1 500 F CFA ». */
export const formatCFA = (amount: number): string => XOF_FORMAT.format(amount);

const AMOUNT_FORMAT = new Intl.NumberFormat('fr-FR', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Montant arrondi à l'unité (par `AMOUNT_FORMAT`, sans décimale) suivi de
 * la devise affichée : « 1 500 FCFA ».
 */
export const formatAmount = (amount: number, currency: string): string =>
  `${AMOUNT_FORMAT.format(amount)} ${currency}`;

const NUMBER_FORMAT = new Intl.NumberFormat('fr-FR');

/** Nombre au format français (séparateur de milliers) : « 12 500 ». */
export const formatNumber = (value: number): string => NUMBER_FORMAT.format(value);

